import { usePM2DisplayContext } from '@pm2/store';
import { jsx } from 'react/jsx-runtime';
import { HarmonicaIframeComponent } from './organisms/harmonica-iframe/comp.harmonica-iframe.js';
import { EmbedIframeComponent } from './organisms/embed-iframe/embed-iframe.js';
import { AnnotatedEmbedIframeComponent } from './organisms/annotated-embed-iframe/annotated-embed-iframe.js';

function IframeComponent(props) {
  const displayContext = usePM2DisplayContext();
  const showAsAccordion = props.desiredDisplayMode === "harmonica" && !displayContext.inLibrary && !displayContext.inLightbox;
  if (showAsAccordion) {
    return /*#__PURE__*/jsx(HarmonicaIframeComponent, {
      ...props
    });
  } else {
    return !props.autoActivate ? /*#__PURE__*/jsx(EmbedIframeComponent, {
      ...props
    }) : /*#__PURE__*/jsx(AnnotatedEmbedIframeComponent, {
      ...props
    });
  }
}

export { IframeComponent };
//# sourceMappingURL=iframe-component.js.map
